import { useCallback } from 'react';

/**
 * Custom hook for period navigation logic
 * @param {Object} params - Navigation parameters
 * @param {Object} params.startDate - Current start date
 * @param {Object} params.endDate - Current end date
 * @param {Object} params.dateCalculations - Pre-calculated date values
 * @param {Function} params.setStartDate - Function to set start date
 * @param {Function} params.setEndDate - Function to set end date
 * @returns {Object} Navigation functions
 */
export const usePeriodNavigation = ({ startDate, endDate, dateCalculations, setStartDate, setEndDate }) => {
  // Memoize the changePeriod function to prevent unnecessary re-renders
  const changePeriod = useCallback((nextPrev) => {
    const { monthsSelected, daysSelected, isCompleteMonthSelection } = dateCalculations;
    const sign = nextPrev === "next" ? 1 : -1;

    if (isCompleteMonthSelection) {
      // Move by complete months
      setStartDate(
        startDate.clone().add(monthsSelected * sign, "months")
      );
      setEndDate(
        endDate.clone().add(monthsSelected * sign, "months").endOf("month")
      );
    } else {
      // Move by the same number of days
      setStartDate(
        startDate.clone().add(daysSelected * sign, "days")
      );
      setEndDate(endDate.clone().add(daysSelected * sign, "days"));
    }
  }, [setStartDate, setEndDate, startDate, endDate, dateCalculations]);

  return {
    changePeriod
  };
};
